/* eslint-disable consistent-return */
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deviceButtonTitle, deviceVariant } from 'constants/device';
import { deviceMapper } from 'services/deviceMapper';
import { SOURCES_NAMES } from 'store/common/basket/constants';
import { getIsItemInBasket } from 'store/common/basket/selectors';
import { addCatalogItemToBasket, onCatalogBuyButtonClick } from 'store/ProductCatalog/actions';
import { openOutOfStockPopup } from 'store/ProductCatalog/outofstock/actions';
import { LOCAL_STORAGE_DATA_KEY } from 'store/ProductCatalog/outofstock/constants';
import { getOutOfStockStorageData } from 'store/ProductCatalog/outofstock/selectors';
import { openPartnerPopup } from 'store/widgets/PartnerOrder/common/actions';
import { setQuantity } from 'store/common/specialProjectHeader/cart';

// TODO разобраться с openPartnerPopup и onCatalogBuyButtonClick
export const useCatalogDevicePurchase = (device) => {
  const [title, setTitle] = useState(deviceButtonTitle.TO_BASKET);
  const isInBasket = useSelector((state) => getIsItemInBasket(state, device?.id?.toString()));

  const dispatch = useDispatch();

  const onOutOfStockClick = useCallback(() => {
    dispatch(openOutOfStockPopup(device.id));
  }, [device]);

  const [variant, setVariant] = useState(
    device.isInBasket ? deviceVariant.SECONDARY : deviceVariant.TERTIARY,
  );

  useEffect(() => {
    if (isInBasket) {
      setVariant(deviceVariant.SECONDARY);
    }
  }, [isInBasket]);

  // перенес функцию из BuyButtonLayout
  const onPurchaseClick = useCallback(() => {
    if (isInBasket) {
      window.location = '/basket';
    } else {
      dispatch(onCatalogBuyButtonClick(device.id, title));
      if (device.partnerSlug) {
        dispatch(openPartnerPopup(device.article, device.partnerSlug, device.title, device.price));
      } else {
        const itemData = {
          brand: device.brandName,
          forceRedirect: true,
          handleSetCartData: setQuantity,
          id: device.id,
          price: device.price.value,
          source: SOURCES_NAMES.PRODUCT_CATALOG_PAGE,
        };

        dispatch(addCatalogItemToBasket(itemData));
      }
    }
  }, [device, dispatch]);

  // перенес функцию из OutOfStockButton
  const { storageData } = useSelector((state) => ({
    storageData: getOutOfStockStorageData(state),
  }));

  useEffect(() => {
    const storage = window?.localStorage;

    if (storage && device.isOutOfStock) {
      const outofstockList = JSON.parse(storage.getItem(LOCAL_STORAGE_DATA_KEY));
      const outOfStockTitleFirst =
        device.isPreorder ?
          deviceButtonTitle.OUT_OF_STOCK_PREORDER
        : deviceButtonTitle.OUT_OF_STOCK;
      const outOfStockTitle =
        outofstockList?.includes(device.id) ? deviceButtonTitle.RESEND : outOfStockTitleFirst;

      return setTitle(outOfStockTitle);
    }

    setTitle(deviceMapper.getButtonText(device.isInBasket, device.isPreorder));
  }, [storageData, device]);

  const onClick = device.isOutOfStock ? onOutOfStockClick : onPurchaseClick;

  return {
    onClick,
    title,
    variant,
  };
};
